import { useConfirmDialog } from "contexts/confirmDialog";
import { useTenantTranslation } from "hooks/formatters";
import { useCallback } from "react";
import { isReviewRefreshRequired } from "../utils/reviewErrors";

export const useReviewSaveError = (): ((
  error: unknown,
  message?: string
) => Promise<void>) => {
  const confirm = useConfirmDialog();
  const { t } = useTenantTranslation();
  return useCallback(
    async (error: unknown, message?: string): Promise<void> => {
      const refreshRequired = isReviewRefreshRequired(error);
      const logSaveFailure = refreshRequired ? console.warn : console.error;
      logSaveFailure("Failed to save review changes", error);
      const accepted = await confirm({
        title: t("globalErrorTitle"),
        message: refreshRequired
          ? t("reviewChangedRefreshRequired")
          : (message ?? t("errorSavingChanges")),
        confirmLabel: refreshRequired ? t("refresh") : undefined,
      });
      if (refreshRequired && accepted) {
        window.location.reload();
      }
    },
    [confirm, t]
  );
};
